import "core-js/modules/es.date.now.js";
import { intlDate } from "@faire/web/common/localization/date-fns/intlDate";
import differenceInDays from "date-fns/differenceInDays";
import { additionalDataRequiredForFaireDiscountsSignUpOfferIA } from "../../shared/instantAnswerUtils";
import { ViewOfferDetailsCTA } from "./ctas";
export var WhenDoesSignupExpireIA = function WhenDoesSignupExpireIA(strictLocalize) {
  return {
    titleBuilder: function titleBuilder(context) {
      var _context$faireDirectD;
      return getAnswer(strictLocalize, (_context$faireDirectD = context.faireDirectDiscountsContext) === null || _context$faireDirectD === void 0 ? void 0 : _context$faireDirectD.discounts).getTitle();
    },
    descriptionBuilder: function descriptionBuilder(context) {
      var _context$faireDirectD2;
      return getAnswer(strictLocalize, (_context$faireDirectD2 = context.faireDirectDiscountsContext) === null || _context$faireDirectD2 === void 0 ? void 0 : _context$faireDirectD2.discounts).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getPrimaryCTA;
        return (_getPrimaryCTA = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA === void 0 ? void 0 : _getPrimaryCTA.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getPrimaryCTA2, _getPrimaryCTA2$getLi;
        return (_getPrimaryCTA2 = getPrimaryCTA(context, strictLocalize)) === null || _getPrimaryCTA2 === void 0 ? void 0 : (_getPrimaryCTA2$getLi = _getPrimaryCTA2.getLink) === null || _getPrimaryCTA2$getLi === void 0 ? void 0 : _getPrimaryCTA2$getLi.call(_getPrimaryCTA2);
      }
    },
    additionalRequiredData: additionalDataRequiredForFaireDiscountsSignUpOfferIA()
  };
};
var getAnswer = function getAnswer(strictLocalize, discounts) {
  if (discounts && discounts[0]) {
    if (discounts.length > 1) {
      return GENERAL_FAIRE_DIRECT_ANSWER(strictLocalize);
    } else if (discounts[0].is_expired) {
      return RELATIONSHIP_EXPIRED_ANSWER(strictLocalize, discounts[0]);
    } else {
      return RELATIONSHIP_NOT_EXPIRED_ANSWER(strictLocalize, discounts[0]);
    }
  } else {
    return NO_RELATIONSHIPS_ANSWER(strictLocalize);
  }
};
var getPrimaryCTA = function getPrimaryCTA(context, strictLocalize) {
  var _context$faireDirectD3;
  var discounts = (_context$faireDirectD3 = context.faireDirectDiscountsContext) === null || _context$faireDirectD3 === void 0 ? void 0 : _context$faireDirectD3.discounts;
  if ((discounts === null || discounts === void 0 ? void 0 : discounts.length) === 1 && discounts[0]) {
    return ViewOfferDetailsCTA(strictLocalize);
  }
  return undefined;
};
var GENERAL_FAIRE_DIRECT_ANSWER = function GENERAL_FAIRE_DIRECT_ANSWER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return GENERAL_FAIRE_DIRECT_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [GENERAL_FAIRE_DIRECT_DESCRIPTION(strictLocalize)];
    }
  };
};
var GENERAL_FAIRE_DIRECT_TITLE = function GENERAL_FAIRE_DIRECT_TITLE(strictLocalize) {
  return strictLocalize({
    id: "lKxnlX",
    defaultMessage: [{
      "type": 0,
      "value": "Hoe werkt de registratie-aanbieding?"
    }]
  });
};
var GENERAL_FAIRE_DIRECT_DESCRIPTION = function GENERAL_FAIRE_DIRECT_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "x52u0e",
    defaultMessage: [{
      "type": 0,
      "value": "Wanneer je je registreert op Faire via de link van een merk, ontvang je een registratie-aanbieding, inclusief een promotie en een jaar gratis verzending bij dat merk. De aanbieding wordt automatisch toegepast bij het afrekenen en verloopt 7 dagen nadat je je registreert."
    }]
  });
};
var RELATIONSHIP_EXPIRED_ANSWER = function RELATIONSHIP_EXPIRED_ANSWER(strictLocalize, relationship) {
  return {
    getTitle: function getTitle() {
      return RELATIONSHIP_EXPIRED_TITLE(strictLocalize, relationship);
    },
    getDescription: function getDescription() {
      return [RELATIONSHIP_EXPIRED_DESCRIPTION(strictLocalize, relationship)];
    }
  };
};
var RELATIONSHIP_EXPIRED_TITLE = function RELATIONSHIP_EXPIRED_TITLE(strictLocalize, relationship) {
  return strictLocalize({
    id: "DKizqc",
    defaultMessage: [{
      "type": 0,
      "value": "Je registratie-aanbieding is verlopen op "
    }, {
      "type": 1,
      "value": "expiryDate"
    }]
  }, {
    expiryDate: intlDate(relationship.expires_at, "PP")
  });
};
var RELATIONSHIP_EXPIRED_DESCRIPTION = function RELATIONSHIP_EXPIRED_DESCRIPTION(strictLocalize, relationship) {
  return strictLocalize({
    id: "ShQ9kz",
    defaultMessage: [{
      "type": 0,
      "value": "Het lijkt erop dat je geen bestelling hebt geplaatst bij "
    }, {
      "type": 1,
      "value": "brandCompanyName"
    }, {
      "type": 0,
      "value": " voordat je registratie-aanbieding is verlopen."
    }]
  }, {
    brandCompanyName: relationship.brand_name
  });
};
var RELATIONSHIP_NOT_EXPIRED_ANSWER = function RELATIONSHIP_NOT_EXPIRED_ANSWER(strictLocalize, relationship) {
  return {
    getTitle: function getTitle() {
      return differenceInDays(relationship.expires_at, Date.now()) === 1 ? RELATIONSHIP_NOT_EXPIRED_TITLE_SINGLE_DAY(strictLocalize) : RELATIONSHIP_NOT_EXPIRED_TITLE(strictLocalize, relationship);
    },
    getDescription: function getDescription() {
      return [RELATIONSHIP_NOT_EXPIRED_DESCRIPTION(strictLocalize, relationship)];
    }
  };
};
var RELATIONSHIP_NOT_EXPIRED_TITLE = function RELATIONSHIP_NOT_EXPIRED_TITLE(strictLocalize, relationship) {
  return strictLocalize({
    id: "zx7KJt",
    defaultMessage: [{
      "type": 0,
      "value": "Je hebt nog "
    }, {
      "type": 1,
      "value": "daysLeftNumber"
    }, {
      "type": 0,
      "value": " dagen om je registratie-aanbieding te gebruiken"
    }]
  }, {
    daysLeftNumber: differenceInDays(relationship.expires_at, Date.now())
  });
};
var RELATIONSHIP_NOT_EXPIRED_TITLE_SINGLE_DAY = function RELATIONSHIP_NOT_EXPIRED_TITLE_SINGLE_DAY(strictLocalize) {
  return strictLocalize({
    id: "f98ytK",
    defaultMessage: [{
      "type": 0,
      "value": "Je hebt nog 1 dag om je registratie-aanbieding te gebruiken"
    }]
  });
};
var RELATIONSHIP_NOT_EXPIRED_DESCRIPTION = function RELATIONSHIP_NOT_EXPIRED_DESCRIPTION(strictLocalize, relationship) {
  return strictLocalize({
    id: "WB3xVz",
    defaultMessage: [{
      "type": 0,
      "value": "Wanneer je je eerste bestelling plaatst bij "
    }, {
      "type": 1,
      "value": "brandCompanyName"
    }, {
      "type": 0,
      "value": ", wordt de registratie-aanbieding automatisch toegepast bij het afrekenen. Houd er rekening mee dat de aanbieding verloopt op "
    }, {
      "type": 1,
      "value": "expiryDate"
    }, {
      "type": 0,
      "value": "."
    }]
  }, {
    brandCompanyName: relationship.brand_name,
    expiryDate: intlDate(relationship.expires_at, "PP")
  });
};
var NO_RELATIONSHIPS_ANSWER = function NO_RELATIONSHIPS_ANSWER(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return NO_RELATIONSHIPS_TITLE(strictLocalize);
    },
    getDescription: function getDescription() {
      return [NO_RELATIONSHIPS_DESCRIPTION(strictLocalize)];
    }
  };
};
var NO_RELATIONSHIPS_TITLE = function NO_RELATIONSHIPS_TITLE(strictLocalize) {
  return strictLocalize({
    id: "iKLc4x",
    defaultMessage: [{
      "type": 0,
      "value": "Je komt niet in aanmerking voor de Faire Direct-aanbieding"
    }]
  });
};
var NO_RELATIONSHIPS_DESCRIPTION = function NO_RELATIONSHIPS_DESCRIPTION(strictLocalize) {
  return strictLocalize({
    id: "rWalf9",
    defaultMessage: [{
      "type": 0,
      "value": "De aanbieding is alleen beschikbaar voor retailers die zich hebben geregistreerd voor een Faire-account via de link van een merk."
    }]
  });
};